import { home } from "./home";
import { episodes, categories } from "./episodes";

// eslint-disable-next-line
export default {
  episodes,
  categories,
  home,
};
